import { render, staticRenderFns } from "./OcrPc.vue?vue&type=template&id=b8240b00&scoped=true"
import script from "./OcrPc.vue?vue&type=script&lang=js"
export * from "./OcrPc.vue?vue&type=script&lang=js"
import style0 from "./OcrPc.vue?vue&type=style&index=0&id=b8240b00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../and-iot-pre-checkin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8240b00",
  null
  
)

export default component.exports